import {Anchor} from '../../../components/ui/infinite-data-table/index.js'
import {BaseRowData} from '../../../types/index.js'

export function createTopAnchor<RowData extends BaseRowData>() {
  const TOP_ANCHOR: Anchor<RowData> = Object.freeze({
    startRow: undefined,
    direction: 'forward',
    index: 0,
  })

  return TOP_ANCHOR
}

export const toArrayIndex = (index: number, anchor: Anchor<BaseRowData>) =>
  anchor.direction === 'forward' ? index - anchor.index : anchor.index - index

export const toBoundArrayIndex = (index: number, anchor: Anchor<BaseRowData>, length: number) =>
  Math.min(length - 1, Math.max(0, toArrayIndex(index, anchor)))

export const toIndex = (arrayIndex: number, anchor: Anchor<BaseRowData>) =>
  anchor.direction === 'forward' ? arrayIndex + anchor.index : anchor.index - arrayIndex
